module.exports = __webpack_public_path__ + "c448bcc872076554a468ca7eb582c987.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/david-khourshid.jpg
// module id = 439
// module chunks = 0